import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import {globalSnackbarStore} from "@/components/Globals/snackbar/global-snackbar";

export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalSnackbar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _unref(globalSnackbarStore).shows,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(globalSnackbarStore).shows) = $event)),
    location: "top",
    timeout: 2500
  }, {
    default: _withCtx(() => [
      (_unref(globalSnackbarStore).icon !== undefined)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            icon: _unref(globalSnackbarStore).icon
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_unref(globalSnackbarStore).message), 1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})